<!-- Back button in top left -->
<!-- we may want to disable this button if we are not onboarding -->
<div class="absolute top-0 left-0 p-4" *ngIf="styleForOnboarding && page!==1">
  <button pButton pRipple type="button" class="p-button-text p-button-plain p-0"
    style="outline: none; box-shadow: none;" (click)="prevPage()">
    <i class="pi pi-arrow-circle-left text-2xl text-600"></i>
  </button>
</div>

<!-- PAGE 1 -->
<form [formGroup]="getPageFormGroup(1)" class="p-fluid" *ngIf="page===1">
  <div class="grid formgrid mb-3">
    <div class="field col-12">
      <div class="p-float-label">
        <input pInputText id="id" formControlName="id" class="w-full" />
        <label for="id">
          {{ 'ORG_ID' | translate }}<span class="required-asterisk text-red-500">*</span>
        </label>
      </div>
    </div>
    <!-- Legal Name and Display Name on one row -->
    <div class="field col-6">
      <div class="p-float-label">
        <input pInputText id="legalName" formControlName="legalName" class="w-full" [readonly]="mode === 'read'" />
        <label for="legalName">
          {{ 'LEGAL_NAME' | translate }}<span class="required-asterisk text-red-500">*</span></label>
      </div>
      <div *ngIf="form.get('legalName')?.invalid && form.get('legalName')?.touched" class="text-red-500 mb-2">
        <small>{{ 'LEGAL_NAME_REQUIRED' | translate }}</small>
      </div>
    </div>
    <div class="field col-6">
      <div class="p-float-label">
        <input pInputText id="displayName" formControlName="displayName" class="w-full" [readonly]="mode === 'read'" />
        <label for="displayName">
          {{ 'DISPLAY_NAME' | translate }}<span class="required-asterisk text-red-500">*</span></label>
      </div>
      <div *ngIf="
          form.get('displayName')?.invalid && form.get('displayName')?.touched
        " class="text-red-500 mb-2">
        <small>{{ 'DISPLAY_NAME_REQUIRED' | translate }}</small>
      </div>
    </div>
    <!-- Contact Email and Telephone on one row -->
    <div class="field col-6">
      <div class="p-float-label">
        <input pInputText id="contactEmail" formControlName="contactEmail" class="w-full"
          [readonly]="mode === 'read'" />
        <label for="contactEmail">
          {{ 'CONTACT_EMAIL' | translate }}<span class="required-asterisk text-red-500">*</span></label>
      </div>
      <div *ngIf="
          form.get('contactEmail')?.invalid && form.get('contactEmail')?.touched
        " class="text-red-500 mb-2">
        <small *ngIf="form.get('contactEmail')?.errors?.['required']">
          {{ 'CONTACT_EMAIL_REQUIRED' | translate }}
        </small>
        <small *ngIf="form.get('contactEmail')?.errors?.['email']">
          {{ 'INVALID_EMAIL_FORMAT' | translate }}
        </small>
      </div>
    </div>
    <div class="field col-6">
      <div class="p-float-label">
        <input pInputText id="contactTelephone" formControlName="contactTelephone" class="w-full"
          [readonly]="mode === 'read'" />
        <label for="contactTelephone">{{ 'CONTACT_TELEPHONE' | translate }}</label>
      </div>
    </div>
    <div class="field col-6">
      <div class="p-float-label">
        <p-dropdown id="country" formControlName="country" [options]="countries" optionLabel="name" optionValue="id"
          [placeholder]="'SELECT_COUNTRY' | translate" class="w-full" appendTo="body" [showClear]="true" [filter]="true"
          [virtualScroll]="false" [virtualScrollItemSize]="38" [scrollHeight]="'150px'" [ngClass]="{
            'p-invalid':
              form.get('country')?.invalid && form.get('country')?.touched
          }">
          <!-- 
            FIXME: this doesn't actually do anything for some reason. It's
            supposed to replace every item in the dropdown with this html that
            includes the country emoji next to the country name.
          -->
          <ng-template let-country pTemplate="item">
            <span>{{ country.emoji }} {{ country.name }}</span>
          </ng-template>
        </p-dropdown>
        <label for="country">
          {{ 'COUNTRY' | translate }}<span class="required-asterisk text-red-500">*</span>
        </label>
      </div>
      <div *ngIf="form.get('country')?.invalid && form.get('country')?.touched" class="text-red-500 mb-2">
        <small>{{ 'COUNTRY_REQUIRED' | translate }}</small>
      </div>
    </div>

    <!-- timezone field -->
    <div class="field col-6">
      <div class="p-float-label">

        <!--
          NOTE: appendTo="body" included here to stop the dropdown search box 
          thing from clipping with its parent component
        -->
        <p-dropdown id="timezone" formControlName="timezoneId" [options]="timezones" optionLabel="tzIdentifier"
          optionValue="id" placeholder="Select Timezone" class="w-full" appendTo="body" [showClear]="true"
          [filter]="true" [virtualScroll]="false" [virtualScrollItemSize]="38" [scrollHeight]="'150px'" [ngClass]="{
            'p-invalid':
              form.get('timezoneId')?.invalid && form.get('timezoneId')?.touched
          }">
        </p-dropdown>
        <label for="timezone">
          Timezone (e.g Europe/London)
          <span class="required-asterisk text-red-500">*</span>
        </label>
      </div>
      <div *ngIf="form.get('timezoneId')?.invalid && form.get('timezoneId')?.touched" class="text-red-500 mb-2">
        <small>Timezone is required.</small>
      </div>
    </div>

    <!-- Address fields: Address Line 1 and 2 on one row, City/Postcode/Country on next row -->
    <div class="field col-6">
      <div class="p-float-label">
        <input pInputText id="addressLine1" formControlName="addressLine1" class="w-full"
          [readonly]="mode === 'read'" />
        <label for="addressLine1">
          {{ 'ADDRESS_LINE_1' | translate }}<span class="required-asterisk text-red-500">*</span></label>
      </div>
    </div>
    <div class="field col-6">
      <div class="p-float-label">
        <input pInputText id="addressLine2" formControlName="addressLine2" class="w-full"
          [readonly]="mode === 'read'" />
        <label for="addressLine2">{{ 'ADDRESS_LINE_2' | translate }}</label>
      </div>
    </div>
    <div class="field col-6">
      <div class="p-float-label">
        <input pInputText id="city" formControlName="city" class="w-full" [readonly]="mode === 'read'" />
        <label for="city">
          {{ 'CITY' | translate }}<span class="required-asterisk text-red-500">*</span>
        </label>
      </div>
    </div>
    <div class="field col-6">
      <div class="p-float-label">
        <input pInputText id="postcode" formControlName="postcode" class="w-full" [readonly]="mode === 'read'" />
        <label for="postcode">{{ 'POSTCODE' | translate }}</label>
      </div>
    </div>
  </div>

  <button *ngIf="mode !=='read'" pButton (click)="nextPage()" label="Next" [disabled]="isCurrentPageInvalid()"></button>
</form>


<!-- PAGE 2 -->
<form [formGroup]="getPageFormGroup(2)" (ngSubmit)="onSave()" *ngIf="page===2">
  <div class="text-left formgrid grid mb-3">
    <div class="field col-12">
      <label class="block text-900 font-medium " for="refractiveInstrument">
        Do you use an autorefactor or aberrometer? <span class="required-asterisk text-red-500">*</span>
      </label>

      <!-- stupid css hack because p-dropdowns won't obey w-full -->
      <p-dropdown id="refractiveInstrument" formControlName="refractiveInstrument" [readonly]="mode === 'read'"
        [options]="getRefractiveInstrumentsWithOther()" placeholder="Select an instrument" [style]="{'width':'100%'}"
        appendTo="body" (onChange)="onRefractiveInstrumentChange($event)"
        *ngIf="!(mode === 'read' && isRefractiveInstrumentOther())" />

      <div *ngIf="shouldShowFieldError('page2', 'refractiveInstrument')" class="text-red-500 mb-2">
        <small>This instrument is required.</small>
      </div>

      <!-- Other input field for refractive instrument -->
      <div *ngIf="isRefractiveInstrumentOther()" class="mt-2">
        <input pInputText id="refractiveInstrumentOther" formControlName="refractiveInstrumentOther" class="w-full"
          [readonly]="mode === 'read'" placeholder="Specify an instrument..." />
      </div>
    </div>

    <div class="field col-12">
      <label class="block text-900 font-medium " for="astigmatismInstrument">
        Which instrument do you use for keratometry?<span class="required-asterisk text-red-500">*</span>
      </label>

      <!-- stupid css hack because p-dropdowns won't obey w-full -->
      <p-dropdown id="astigmatismInstrument" formControlName="astigmatismInstrument" [readonly]="mode === 'read'"
        [options]="getAstigmatismInstrumentsWithOther()" placeholder="Select an instrument" [style]="{'width':'100%'}"
        appendTo="body" (onChange)="onAstigmatismInstrumentChange($event)"
        *ngIf="!(mode === 'read' && isAstigmatismInstrumentOther())" />

      <div *ngIf="shouldShowFieldError('page2', 'astigmatismInstrument')" class="text-red-500 mb-2">
        <small>This instrument is required.</small>
      </div>

      <!-- Other input field for astigmatism instrument -->
      <div *ngIf="isAstigmatismInstrumentOther()" class="mt-2">
        <input pInputText id="astigmatismInstrumentOther" formControlName="astigmatismInstrumentOther" class="w-full"
          [readonly]="mode === 'read'" placeholder="Specify an instrument..." />
      </div>
    </div>

    <div class="field col-12">
      <label class="block text-900 font-medium " for="cataractInstrument">
        Do you use an axial length measurement device?<span class="required-asterisk text-red-500">*</span>
      </label>

      <!-- stupid css hack because p-dropdowns won't obey w-full -->
      <p-dropdown id="cataractInstrument" formControlName="cataractInstrument" [readonly]="mode === 'read'"
        [options]="getCataractInstrumentsWithOther()" placeholder="Select an instrument" [style]="{'width':'100%'}"
        appendTo="body" (onChange)="onCataractInstrumentChange($event)"
        *ngIf="!(mode === 'read' && isCataractInstrumentOther())" />

      <div *ngIf="shouldShowFieldError('page2', 'cataractInstrument')" class="text-red-500 mb-2">
        <small>This instrument is required.</small>
      </div>

      <!-- Other input field for cataract instrument -->
      <div *ngIf="isCataractInstrumentOther()" class="mt-2">
        <input pInputText id="cataractInstrumentOther" formControlName="cataractInstrumentOther" class="w-full"
          [readonly]="mode === 'read'" placeholder="Specify an instrument..." />
      </div>
    </div>
  </div>


  <button *ngIf="mode !== 'read'" pButton type="submit"
    [label]="mode === 'create' ? 'Create' : 'Update' + ' Organisation'" class="w-full"
    [disabled]="form.invalid"></button>
</form>

<div *ngIf="mode === 'read'" class="flex align-items-center justify-content-center gap-2 mt-4">
  <button pButton pRipple type="button" class="p-button-text p-button-plain p-2" [disabled]="page === 1"
    (click)="prevPage()" pTooltip="Previous page" tooltipPosition="top">
    <i class="pi pi-chevron-left text-xl"></i>
  </button>
  <span class="text-sm text-600 mx-2">{{ page }} / 2</span>
  <button pButton pRipple type="button" class="p-button-text p-button-plain p-2" [disabled]="page === 2"
    (click)="nextPage()" pTooltip="Next page" tooltipPosition="top">
    <i class="pi pi-chevron-right text-xl"></i>
  </button>
</div>